export default __webpack_public_path__ + "static/media/shop3.4f58a5ad.jpeg";